const productQty = [1, 3, 6];
const defaultPlans = [1, 3, 6];

let products = [];

if (typeof methylated !== 'undefined') {
    if (!mainProduct.title.toLowerCase().includes('sonne')) {
        nonMethylated = formatProducts(mainProduct.variants.filter((prod) => !prod.options.includes("Methylated")));
        methylated = formatProducts(mainProduct.variants.filter((prod) => prod.options.includes("Methylated")));
    } else {
        methylated = formatProducts(mainProduct.variants.filter((prod) => !prod.options.includes("16 oz")));
        nonMethylated = formatProducts(mainProduct.variants.filter((prod) => prod.options.includes("16 oz")));
    }
    products = nonMethylated;
    if (methylated.length === 3) {
        methylated.pop();
    }

} else {
    products = formatProducts(mainProduct.variants);
}

if (products.length === 3) {
    products.pop();
}

function formatProducts(variants) {
    return variants.map((prod, index) => {
        prod.price = +((wholeSalePrice[prod.id] ? wholeSalePrice[prod.id] : prod.price) / 100)?.toFixed(2);
        prod.discount_symbol = '%';
        if (mainProduct.selling_plan_groups.length) {
            prod.selling_plan_groups = mainProduct.selling_plan_groups;
            prod.discountPrice1 = prod.price * prod.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value;
            prod.discountPrice1 = index === 0 ? (prod.price * 15) : prod.price;
            prod.discountPrice = prod.discountPrice1 / 100;
            prod.totalDiscountPrice = prod.discountPrice1;
            prod.finalDiscountedPrice = prod.price - prod.discountPrice;
            prod.youSaveMoney = prod.price - prod.finalDiscountedPrice;
            prod.discountPricePerItem = prod.finalDiscountedPrice / productQty[index];
            prod.quntity = productQty[index];
            prod.converted_price = prod.price;
            prod.percentage = prod.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value;
            prod.selectedPlan = defaultPlans[index];
            prod.per_item_price = (prod.converted_price / prod.quntity)?.toFixed(2);
        } else {
            prod.noSub = true;
        }

        return prod;
    });
}


let cleared = false;
const cartBtnTotal = document.querySelectorAll('.cart-amount');
let productPerItem = document.querySelectorAll('.per-bottle');
const formOneTime = document.getElementById('ot-price');
const formSubTotal = document.getElementById('sub-price');
const subInput = document.getElementById('subscription');
const oneTimeInput = document.getElementById('one-time');
const cartButton = document.querySelectorAll('.cart-btn');
let selectedIndex = 0;
let isSubscription = true;
currencySym = '$';

if (wholeSalePrice[products[0].id]) {
    document.getElementById('sub-element')?.remove();
    isSubscription = false;
}


window.addEventListener('unload', function (event) {
    console.log('Page is being unloaded');
});


function selectFrequency(elem) {
    document.querySelector('.frequency .selected')?.classList.remove('selected');
    elem.classList.add('selected');
}


/********************************************
 *
 * Checkout handler
 *
 ********************************************/
function optionClickHandler(elem, index) {
    if (index === 1) {
        isSubscription = false;
        document.querySelector('.otp').classList.add('discounted-price');
    } else {
        document.querySelector('.otp').classList.remove('discounted-price');
    }
    document.querySelector('.quantity .selected')?.classList.remove('selected');
    elem.classList.add('selected');
    selectedIndex = index;
    togglePurchaseOption(true);
}



async function togglePurchaseOption(planChanged = false) {
    // clearCart(false);
    const product = products[selectedIndex];

    if (product.noSub) {
        return;
    }
    const isSub = isSubscription;
    if (subInput) {
        subInput.checked = isSub;
    }
    oneTimeInput.checked = !isSub;
    const totalPrice = (isSub ? product.finalDiscountedPrice : product.converted_price)?.toFixed(2);
    cartBtnTotal.forEach((c) => {
        c.textContent = currencySym + totalPrice;
    });
    formOneTime.textContent = currencySym + product.converted_price.toFixed(2);
    if (formSubTotal) {
        formSubTotal.textContent = currencySym + product.finalDiscountedPrice.toFixed(2);
    }
    if (planChanged) {
        products.forEach((prod, i) => {
            if (productPerItem[i]) {
                productPerItem[i].textContent = currencySym + (((isSub && i === 0) ? +prod.discountPricePerItem : +prod.per_item_price).toFixed(2));
            }
        });
    }


}


togglePurchaseOption(true);

let processing = false;
let cartProcessing = false;

async function addToCart(redirect = false) {
    if (cartProcessing) return;
    const tosChecked = document.getElementById('countryTos').checked;
    if (!isUS && !tosChecked) {
        document.getElementById('tos-error').classList.add('active');
        return;
    }
    cartProcessing = true;
    cartButton.forEach(b => b.classList.add('active'));
    let data;


    if (!bundleProducts) {
        const product = products[selectedIndex];
        const frequencyId = document.querySelector('.frequency .selected')?.getAttribute('data-id');
        let selling_plan = !product.noSub ? frequencyId : null;
        if (isSubscription) {
            data = {
                items: [{
                    "id": product.id,
                    "quantity": 1,
                    "selling_plan": selling_plan
                }],
                sections: 'cart-section',
            };
        } else {
            data = {
                items: [{
                    "id": product.id,
                    "quantity": 1
                }],
                sections: 'cart-section',
            };
        }
    } else {

        data = {
            items: bundleProducts.map(p => {
                const productData = {
                    id: p.variants[0].id,
                    quantity: 1,
                }

                if (isSubscription) {
                    productData['selling_plan'] = p.selling_plan_groups[0].selling_plans[0].id
                }
                return productData
            }),
            attributes: {
                'qsb': mainProduct.title.replace(' Quick Start Bundle', '').replace(' - ', '-').replaceAll(' ', '-'),
            },
            sections: 'cart-section',
        };
    }
    // }

    updatedAddedProducts(mainProduct.id);
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(async (response) => {
        cartProcessing = false;
        vwoAddToCart();
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }


        cartButton.forEach(b => b.classList.remove('active'));
        const body = await response.json();

        if (redirect) {
            location.href = '/checkout';
            return;
        }

        // if (freeGiftActive) {
        updateCartData(body);
        updateCartBadge(1);
        addDiscountProduct();
        // document.querySelector('.checkout-btn').scrollIntoView({behavior: 'smooth'});
        // } else {
        // insertRow(body);
        // }
    }).catch((error) => {
        cartProcessing = false;
        cartButton.forEach(b => b.classList.remove('active'));
        console.log(error);
        alert('An error occurred while processing your request. Please try again later.');
    });


    // flyToCart();


}

document.querySelectorAll('.opt-label').forEach((el) => {
    el.addEventListener('click', (e) => {
        document.querySelector('.custom_radio.active')?.classList?.remove('active');
        el.parentElement.classList.add('active');
        isSubscription = el.getAttribute('for') === 'subscription';
        if (isSubscription) {
            selectedIndex = 0;
        }
        optionClickHandler(document.querySelector('.otp-box'), selectedIndex);
        // togglePurchaseOption(true);
    });
});


/********************************************
 *
 * DHT Pill Popper
 *
 ********************************************/
const closed = document.querySelector('#close-pill');
const open = document.querySelector('#open-pill');
let hasPopped = false;

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.left >= 0 &&
        rect.top >= -400 &&
        (rect.bottom - 100) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

document.addEventListener('scroll', function () {
    return;
    const box = hasPopped ? open : closed;
    if (!hasPopped && isInViewport(box)) {
        hasPopped = true;
        document.querySelector('.product-capsule').classList.add('reverse');
    } else if (hasPopped && !isInViewport(box)) {
        hasPopped = false;
        document.querySelector('.product-capsule').classList.remove('reverse');
    }

}, {
    passive: true
});

/********************************************
 *
 * FAQs handler
 *
 ********************************************/
function toggleFaq(e) {
    const openedFaq = document.querySelector('.faq.opened .title');
    if (openedFaq && openedFaq !== e) {
        openedFaq.style.transform = '';
        openedFaq.parentElement.classList.remove('opened');
    }

    if (e.parentElement.classList.contains('opened')) {
        e.parentElement.style.transform = '';
    } else {
        if (window.innerWidth < 768) {
            e.parentElement.style.transform = 'translateY(' + (-e.offsetTop + 66) + 'px)';
        } else {
            e.parentElement.style.transform = 'translateY(' + (-e.offsetTop + 133) + 'px)';
        }
    }
    e.parentElement.classList.toggle('opened');
}

/********************************************
 *
 * Mobile Slider Range for DHT products Card
 *
 ********************************************/
let isUS = true;

fetch('https://d43or1ujf2spv.cloudfront.net', {
    method: 'get'
}).then((response) => {
    if (response.status === 403) {
        isUS = false;
        document.querySelector('.tos-box').classList.add('active');
        document.querySelector('.product-form').classList.add('global');
    }
}).catch((err) => {
    console.log(err);
})

function removeTosError() {
    setTimeout(() => {
        if (document.getElementById('countryTos').checked) {
            document.getElementById('tos-error').classList.remove('active');
        }
    }, 500);
}


// Select the target element
const targetElement = document.querySelector('.product-360');


const bottomStrip = document.querySelector('.bottom-strip')
// Callback function for the observer
const observerCallback = (entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            bottomStrip.classList.remove('active');
            console.log('Element appeared in the viewport!');
            // Add any action when the element reappears in the viewport
        } else {
            console.log(entry);
            bottomStrip.classList.add('active');
            console.log('Element disappeared from the viewport!');
            // Add any action when the element disappears from the viewport
        }
    });
};

// Options for the observer
const observerOptions = {
    root: null, // Use the viewport as the root
    threshold: 0, // Trigger when even 1px of the element is visible
};

// Create the observer
const observer = new IntersectionObserver(observerCallback, observerOptions);

// Start observing the target element
if (targetElement) {
    observer.observe(targetElement);
}



